export default __webpack_public_path__ + "static/media/fitness-tracker-graphql.0cf6d969.jpg";